import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";
import TableTopicsData from "../../../Pages/IndividualUnit/TableTopicsData";
import TopicDetailsModal from "./TopicsDetailModal";
import WeekSelector from "./WeekSelector";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { Card, CardBody, Nav, NavItem, NavLink, Row, Spinner } from "reactstrap";

import StudentIssueTable from "./StudentIssueTable"

import React, {
  useEffect,
  forwardRef,
  useImperativeHandle,
  useState,
} from 'react';

const TopicDiscussedTab = ({ fullURL, payload, resetTrigger, summarystudent, isApiLoading, urlWeek }) => {
  const [selectedWeeks, setSelectedWeek] = useState(null);
  console.log("selectedWeeks", selectedWeeks)
  const [tableDisplayData, setTableDisplayData] = useState([]); // This will hold data for the table
  const [fullTopicData, setFullTopicData] = useState({}); // This will hold the raw data from API, including Q&A
  const [weeks, setWeeks] = useState({});
  const [activeSubtab, setActiveSubtab] = useState('Topics Covered');
  const [loading, setloading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [modalContent, setModalContent] = useState([]);
  const [modalTitle, setModalTitle] = useState('');
  const [weekPeriod, setweekPeriod] = useState(null);
  const [tableissuesDisplayData, settableissuesDisplayData] = useState([]); // This will hold data for the table
  const [studentIssueSummary, setStudentIssueSummary] = useState([]); // || [] This will hold data for the table
  const [studentIssueProactive, setStudentIssueProactive] = useState([]); // || [] This will hold data for the table
  const [summaryAllTopics, setSummaryTopics] = useState("");

  const toggleSubTab = (tab) => {
    setActiveSubtab(tab);
  };
  useEffect(() => {
    // Reset weeks state when resetTrigger changes
    setOpenModal(false);
    setWeeks({});
    setSelectedWeek(null);
    setweekPeriod(null);
    setTableDisplayData([]);
    settableissuesDisplayData([]);
    setloading(false);
    setSummaryTopics("")
    setloading(false);

  }, [resetTrigger]);

  useEffect(() => {
    if (!selectedWeeks) return;
    if (!payload || Object.keys(payload).length === 0) return;

    fetchTableData();
  }, [selectedWeeks, payload]);

  useEffect(() => {
    if (!urlWeek) return;

    const weekNumber = Number(urlWeek);
    if (isNaN(weekNumber)) return;

    const weekObj = {
      label: `Week #${weekNumber}`,
      value: weekNumber,
    };

    setSelectedWeek(weekObj);
  }, [urlWeek]);
  const user_token = localStorage.getItem('usertoken');
  const fetchTableData = async () => {
    setweekPeriod(null);
    setloading(true);
    if (!payload || Object.keys(payload).length === 0) return;
    console.warn('payloadss', payload);
    let config = {
      headers: {
        Authorization: `Token ${user_token}`,
      },
    };
    try {
      const tableres = await axios.post(fullURL, {
        ...payload,
        mode: 'insights',
        week: selectedWeeks?.label,
      }, config);

      console.warn({ tableres });
      settableissuesDisplayData(
        tableres?.issues,
      );
      setStudentIssueSummary(
        tableres?.student_issues_summary || []
      );
      setStudentIssueProactive(
        tableres?.student_issues_proactive || []
      );
      setSummaryTopics(tableres?.summary || "")
      if (tableres) {
        setFullTopicData(tableres?.topics);
        setweekPeriod(tableres.week);
        const transformedData = Object.keys(tableres?.topics).map(
          (topicName, index) => {
            const questions = tableres.topics[topicName].clusters;
            const studentCount = questions.reduce(
              (sum, item) => sum + item.student_count,
              0,
            );
            const questionsCount = questions.length;

            return {
              id: index + 1,
              topicName: topicName,
              Noofstudentsasked: tableres.topics[topicName].total_students,
              Noofquestionsasked: questionsCount,
            };
          },
        );

        const sortedData = transformedData.sort(
          (a, b) => b.Noofstudentsasked - a.Noofstudentsasked,
        );

        setTableDisplayData(sortedData);
      }
    } catch (error) {
      console.error('Error fetching table data:', error);
      setTableDisplayData([]); // Clear data on error
      setFullTopicData({});
    } finally {
      setloading(false);
    }
  };

  // useEffect(() => {
  //   if (!selectedWeeks) {
  //     setTableDisplayData([]);
  //     setweekPeriod(null);
  //     settableissuesDisplayData([]);
  //     setSummaryTopics("")
  //     setloading(false);
  //   }
  // }, [selectedWeeks]);


  useEffect(() => {
    if (!selectedWeeks && !urlWeek) {
      setTableDisplayData([]);
      setweekPeriod(null);
      settableissuesDisplayData([]);
      setSummaryTopics("");
      setloading(false);
    }
  }, [selectedWeeks, urlWeek]);

  useEffect(() => {
    setWeeks({});
  }, [fullURL]);

  useEffect(() => {
    console.warn('selectedWeeks', selectedWeeks);
    if (selectedWeeks) {
      fetchTableData();
    }
  }, [selectedWeeks, payload]);

  useEffect(() => {
    console.warn('payload', payload);
    if (!payload || Object.keys(payload).length === 0) return;
    let config = {
      headers: {
        Authorization: `Token ${user_token}`,
      },
    };
    const fetchWeeks = async () => {
      try {
        const weekres = await axios.post(fullURL, {
          ...payload,
          mode: 'insights',
        }, config);
        if (weekres && weekres && weekres.weeks) {
          setWeeks(weekres.weeks);
        }
      } catch (error) {
        console.error('Error fetching weeks:', error);
      }
    };

    fetchWeeks();
  }, [fullURL, payload]);

  const handleTopicClick = (topicName) => {
    const topicDetails = fullTopicData[topicName];
    setModalContent(topicDetails);
    setModalTitle(topicName);
    setOpenModal(true);
    // }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setModalContent([]);
    setModalTitle('');
  };



  return (
    <div>

      {/* ================= FIRST CARD ================= */}
      <Card className="mb-2">
        <CardBody>

          {/* Header */}
          <div className="d-flex align-items-center mb-3">
            <div>
              {weekPeriod && (
                <p className="mb-2">
                  Week Period :
                  <strong className="ms-1">
                    {weekPeriod}
                  </strong>
                </p>
              )}
            </div>

            <div className="ms-auto">
              <WeekSelector
                weeks={weeks}
                selectedWeeks={selectedWeeks}
                setSelectedWeek={setSelectedWeek}
              />
            </div>
          </div>

          {/* Loader */}
          {isApiLoading || loading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: '200px' }}
            >
              <Spinner style={{ width: '3rem', height: '3rem' }} />
            </div>
          ) : (
            <>
              {selectedWeeks ? (
                <>
                  {/* Tabs */}
                  <Nav tabs>
                    <NavItem>
                      <NavLink
                        active={activeSubtab === 'Topics Covered'}
                        onClick={() => toggleSubTab('Topics Covered')}
                        style={{ cursor: 'pointer' }}
                      >
                        Topics Covered
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink
                        active={activeSubtab === 'Student Issues'}
                        onClick={() => toggleSubTab('Student Issues')}
                        style={{ cursor: 'pointer' }}
                      >
                        Student Issues
                      </NavLink>
                    </NavItem>
                  </Nav>

                  {/* Topics Covered */}
                  {activeSubtab === 'Topics Covered' && (
                    <TableTopicsData
                      noRowsLabel="No Call Insights Available for this Week"
                      topicsData={tableDisplayData}
                      onTopicClick={handleTopicClick}
                      columns={[
                        { field: 'sno', headerName: 'S.No', width: 80, align: 'center' },
                        { field: 'topicName', headerName: 'Topics', flex: 1 },
                        {
                          field: 'Noofstudentsasked',
                          headerName: 'No of Students Asked',
                          width: 230,
                          align: 'center',
                        },
                        {
                          field: 'Noofquestionsasked',
                          headerName: 'No of Questions Asked',
                          width: 230,
                          align: 'center',
                        },
                      ]}
                    />
                  )}

                  {/* Student Issues */}
                  {/* {activeSubtab === 'Student Issues' && (
                  <div className="mt-3">
                    {Object.keys(tableissuesDisplayData || {}).length > 0 ? (
                      Object.keys(tableissuesDisplayData).map((topic) => (
                        <div
                          key={topic}
                          className="mb-2 p-3 border rounded bg-light"
                        >
                          <h6 className="fw-bold">{topic}</h6>
                          <ul className="ps-3 mb-0">
                            {tableissuesDisplayData[topic].map((issue, idx) => (
                              <li key={idx}>{issue}</li>
                            ))}
                          </ul>
                        </div>
                      ))
                    ) : (
                      <p className="text-muted">No Student Issues Available</p>
                    )}
                  </div>
                )} */}
                  {activeSubtab === 'Student Issues' && (
                    <div className="row mt-2">
                      <div className="col-md-12">
                        {console.log(tableissuesDisplayData)}
                        {tableissuesDisplayData && Object.keys(tableissuesDisplayData).length > 0 ? (
                          Object.keys(tableissuesDisplayData).map((category, categoryIndex) => {
                            const categoryData = tableissuesDisplayData[category];
                            const studentIssueSummaryData = studentIssueSummary[category];
                            const formatTitle = (str) =>
                              str.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());



                            return (
                              <div key={categoryIndex} className="mb-3">
                                {/* Category Title */}
                                <h4 className="fw-bold mb-2">{formatTitle(category)}</h4>

                                {/* NOT IN PROD */}
                                <div>
                                  <span className="text-uppercase text-muted fw-bold tracking-wider small d-block mb-1" style={{ letterSpacing: '0.05em', fontSize: '0.75rem' }}>
                                    Summary
                                  </span>
                                  <p className="mb-3 lh-base">
                                    {studentIssueSummaryData || "No Summary available"}
                                  </p>
                                </div>
                                {/* Topics inside this category */}
                                {Object.keys(categoryData).map((topic, topicIndex) => (
                                  <div
                                    key={topicIndex}
                                    className="mb-2 p-3 pb-1 border rounded shadow-sm bg-light"
                                  >
                                    {/* Topic Title */}
                                    <h6 className="fw-bold mb-2">{topic}</h6>

                                    {/* Issues list */}
                                    <ul className="ps-3">
                                      {categoryData[topic].map((issue, issueIndex) => (
                                        <li key={issueIndex} className="mb-1 text-dark">
                                          {issue}
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                ))}
                              </div>
                            );
                          })
                        ) : (
                          <p className="ms-3">No Student Issues Available</p>
                        )}
                      </div>
                      {/* NOT IN PROD */}
                      <h4 className="fw-bold mb-1">Students Flagged Based on 1:1 Session Engagement</h4>
                      <p className="text-muted mb-3 mt-0 pt-0">
                        This list is generated based on students who have had at least one 1:1 consultation session with their facilitator during the previous week.
                      </p>
                      <StudentIssueTable StudentList={studentIssueProactive} />
                    </div>
                  )}
                </>
              ) : (
                <p className="text-muted text-center mt-3">
                  Please Select the week to view Call Insights
                </p>
              )}
            </>
          )}

        </CardBody>
      </Card>

      {/* ================= SECOND CARD ================= */}
      <Card className="mb-2">
        <CardBody>
          <h5 className="fw-bold mb-2">AI Summary of All Topics</h5>

          {weekPeriod ? (
            <div
              className="va-summary-main"
              dangerouslySetInnerHTML={{
                __html: summaryAllTopics || 'No Summary Available.',
              }}
            />
          ) : (
            <p className="text-muted text-center mb-0">
              Please Select the week to view AI Summary
            </p>
          )}
        </CardBody>
      </Card>

      {/* Modal */}
      <TopicDetailsModal
        open={openModal}
        onClose={handleCloseModal}
        title={modalTitle}
        contentDetails={modalContent?.clusters}
      />

    </div>
  );

};

export default TopicDiscussedTab;
